import React from 'react';

import {
    Box,
    Flex,
    Text,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Image,
    SimpleGrid,
    ListItem,
    ListIcon,
    List,
    BoxProps,
} from '@chakra-ui/react';

import { CheckIcon } from '@chakra-ui/icons';

import { Link } from '@chakra-ui/react';
import { StyledHeading, StyledHighlight } from '../../sections/CalltoActionSection/styles';

interface TabContent {
    tabTitle?: string;
    tabName: string;
    imgUrl: string;
    list: { item: string; href?: string }[];
}

interface TabsSectionProps extends BoxProps {
    title: string;
    subtitle: string;
    tabsContent: TabContent[];
}

const TabsSection: React.FC<TabsSectionProps> = ({ title, subtitle, tabsContent, ...rest }) => {
    // const [selectedTab, setSelectedTab] = useState(0);
    const defaultSelectedTab = 0;

    return (
        <Box {...rest}>
            <Flex pb={4} alignItems="center" flexDirection="column" className="text-main">
                <StyledHeading> {title}</StyledHeading>
                <Text mt={2} textAlign="center" fontSize="lg">
                    {subtitle}
                </Text>
            </Flex>
            <Tabs
                isFitted
                variant="line"
                colorScheme="teal"
                mt={4}
                w="100%"
                defaultIndex={defaultSelectedTab}
            >
                {tabsContent.length > 1 && (
                    // We want show tabs only if there is more than one tab
                    <TabList overflowX={'auto'} overflowY={'hidden'}>
                        {tabsContent.map((tab, index) => (
                            <Tab
                                key={index}
                                _selected={{
                                    color: 'black',
                                    borderBottom: '3px solid #1AAC7A',
                                    outline: 'none',
                                    fontWeight: 'bold',
                                }}
                                _focus={{ outline: 'none' }}
                                whiteSpace={'nowrap'}
                                pb={2}
                            >
                                {tab.tabName}
                            </Tab>
                        ))}
                    </TabList>
                )}
                <TabPanels className="frame-2">
                    {tabsContent.map((tab, index) => (
                        <TabPanel key={index} className="frame-3" mt={5}>
                            <SimpleGrid
                                templateColumns="repeat(2, 1fr)"
                                gap="30px"
                                gridTemplateColumns={{
                                    sm: 'templateColumns="1fr"',
                                    lg: 'repeat(2, 1fr)',
                                }}
                            >
                                <Box my="auto">
                                    <List className="item-wrapper">
                                        {tab.tabTitle && (
                                            <Text
                                                fontSize="25px"
                                                fontWeight="bold"
                                                className="text-wrapper-2"
                                                color="#1AAC7A"
                                                marginBottom={4}
                                            >
                                                {tab.tabTitle}
                                            </Text>
                                        )}
                                        {tab.list.map((item, itemIndex) => (
                                            <ListItem
                                                py={4}
                                                key={itemIndex}
                                                className="text"
                                                fontSize={{
                                                    base: 'md',
                                                    lg: 'lg',
                                                }}
                                                fontWeight="bold"
                                                display={'flex'}
                                            >
                                                <ListIcon
                                                    as={CheckIcon}
                                                    color="#1AAC7A"
                                                    marginTop={'10px'}
                                                    marginRight={'30px'}
                                                    fontWeight={'900'}
                                                    fontSize={{
                                                        base: 'md',
                                                        lg: '2xl',
                                                    }}
                                                />
                                                {item.href ? (
                                                    <Link
                                                        href={item.href}
                                                        isExternal
                                                        _hover={{
                                                            color: '#171717',
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        {item.item}
                                                    </Link>
                                                ) : (
                                                    item.item
                                                )}
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>

                                <Image src={tab.imgUrl} my="auto" />
                            </SimpleGrid>
                        </TabPanel>
                    ))}
                </TabPanels>
            </Tabs>
        </Box>
    );
};

export default TabsSection;
